// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { QuartelState } from '../_reducers/quartel.reducers';
import { Quartel } from '../_models/quartel.model';

export const selectQuartelsState = createFeatureSelector<QuartelState>('quartels');

export const selectQuartelById = (quartelId: number) => createSelector(
    selectQuartelsState,
    quartelsState => quartelsState.entities[quartelId]
);

export const selectQuartelsPageLoading = createSelector(
    selectQuartelsState,
    quartelsState => quartelsState.listLoading
);

// export const selectQuartelsActionLoading = createSelector(
//     selectQuartelsState,
//     customersState => customersState.actionsloading
// );

export const selectQuartelsPageLastQuery = createSelector(
    selectQuartelsState,
    quartelsState => quartelsState.lastQuery
);

export const selectLastCreatedQuartelId = createSelector(
    selectQuartelsState,
    quartelsState => quartelsState.lastCreatedQuartelId
);

export const selectLastUpdatedQuartelId = createSelector(
    selectQuartelsState,
    quartelsState => quartelsState.lastUpdatedQuartelId
);

export const selectLastDeletedQuartelId = createSelector(
    selectQuartelsState,
    quartelsState => quartelsState.lastDeletedQuartelId
);

export const selectQuartelsInitWaitingMessage = createSelector(
    selectQuartelsState,
    quartelsState => quartelsState.showInitWaitingMessage
);

export const selectQuartelsInStore = createSelector(
    selectQuartelsState,
    quartelsState => {
        const items: Quartel[] = [];
        each(quartelsState.entities, element => {
            items.push(element);
        });
        const httpExtension = new HttpExtenstionsModel();
        const result: Quartel[] = httpExtension.sortArray(items, quartelsState.lastQuery.sortField, quartelsState.lastQuery.sortOrder);
        return new QueryResultsModel(result, quartelsState.totalCount, '');
    }
);

export const selectHasQuartelsInStore = createSelector(
    selectQuartelsInStore,
    queryResult => {
        if (!queryResult.totalCount) {
            return false;
        }

        return true;
    }
);